import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import API from '../../services/api'
import { Toast } from '../../shared/Toast'
import { SlButton, SlDrawer } from '@shoelace-style/shoelace/dist/react'
import {formatDateYYYYMMDD} from '../../utils/dateFormat'

function Events(props) {
    const [events, setEvents] = useState([])
    const [eventAdd, setEventAdd] = useState(false)
    const form1 = useForm()
    const form2 = useForm()
    function handleRequestClose(event) {
        if (event.detail.source === "overlay") {
            event.preventDefault();
        }
    }
    const onSubmit = async (data) => {
        if(props.flag !== 'edit'){
        try {
            let res = await API({
                url: '/sales_contacts/add_event',
                method: 'POST',
                responseType: 'json',
                data: {
                    ...data, contact_id: props.details?.contact_id 
                }
            })
            if (res.code === 200) {
                Toast('success', 'Event added Successfully!')
                props.setShow(false)
                props.loadData()
            }
            else{
                Toast('error', 'Error in adding event!')
            }
        } catch (error) {
            console.error(error)
        }
                    
    }
    else{
        try {
            let res = await API({
                url: '/sales_contacts/edit_event',
                method: 'POST',
                responseType: 'json',
                data: {
                    ...data, event_id: props.data?.event_id
                }
            })
            if (res.code === 200) {
                Toast('success', 'Event edited Successfully!')
                props.setShow(false)
                props.loadData()
            }
            else{
                Toast('error', 'Error in editing event!')
            }
        } catch (error) {
            console.error(error)
        }
    }
    }

    const fetchEvents = async () => {
        try {
            let res = await API({
                url: '/sales_contacts/get_event_types',
                method: 'POST',
                responseType: 'json',
                data: {}
            })
            if (res.code === 200) {
                setEvents(res.data)
            }
        } catch (error) {
            console.error(error)
        }
    }

    const addEvent = async (data) => {
        try {
            let res = await API({
                url: '/sales_contacts/add_event_type',
                method: 'POST',
                responseType: 'json',
                data: {
                    event_name: data.event_name
                }
            })
            if (res.code === 200) {
                setEventAdd(false)
                Toast('success', 'Event type added')
                fetchEvents()
            }
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        fetchEvents()
    }, [])


    useEffect(() => {
        if(props.flag === "edit"){
            form1.setValue('event', props.data.event_id)
            form1.setValue('date', formatDateYYYYMMDD(props.data.event_date))
            form1.setValue('description', props.data.description)
        }
    },[events])

    return (
        <>
            <SlDrawer
                label="Events"
                open={props.show}
                onSlRequestClose={handleRequestClose} onSlAfterHide={() => props.setShow(false)}>
                <form onSubmit={form1.handleSubmit(onSubmit)}>
                    <div className='mb-3'>
                        <div className='d-flex justify-between mb-1'>
                            <label className='form-label'>Select Event Type</label>
                            <SlButton variant='primary' onClick={() => setEventAdd(true)} size='small'>Add</SlButton>
                        </div>
                        <select className='form-control' {...form1.register('event', { required: true })}>
                            <option value="">Please chooose</option>
                            {events?.length && events?.map((item) => (<option value={item.value} key={item.value}>{item.label}</option>))}
                        </select>
                        {form1.formState.errors?.event ? <p className='text-red-600'>Please select an event!</p> : null}
                    </div>
                    <div className='mb-3'>
                        <label className='form-label'>Choose Date</label>
                        <input type='date' className='form-control'  {...form1.register('date', { required: true })} />
                        {form1.formState.errors?.date ? <p className='text-red-600'>Please select a date!</p> : null}

                    </div>
                    <div className='mb-3'>
                        <label className='form-label'>Description</label>
                        <textarea rows={2} className='form-control' placeholder='Please write description about the event' {...form1.register('description', { required: true })}></textarea>
                        {form1.formState.errors?.description ? <p className='text-red-600'>Please enter description</p> : null}

                    </div>
                    <div>
                        <SlButton type='submit' variant='primary' size='small' className='w-full'>Submit</SlButton>
                    </div>
                </form>
            </SlDrawer>

            <SlDrawer label='Add Event Type' open={eventAdd} onSlRequestClose={handleRequestClose} onSlAfterHide={() => setEventAdd(false)}>
                <form onSubmit={form2.handleSubmit(addEvent)}>
                    <div className='mb-3'>
                        <label className='form-label'>Event Type</label>
                        <input type='text' className='form-control' placeholder='Enter event name' {...form2.register('event_name', { required: true })}></input>
                        {form2.formState.errors.event_name && <p className='text-red-600'>Enter event name!</p>}
                    </div>
                    <div>
                        <SlButton type='submit' variant='primary' size='small' className='w-full'>Submit</SlButton>
                    </div>
                </form>
            </SlDrawer>
        </>
    )
}

export default Events